import classNames from "classnames";
import React, { CSSProperties, FunctionComponent } from "react";
import { fontTagToCssClass } from "../../../../agreed/fonts";
import { ContentDateCell } from "../../../../types/customization/content";
import {
  Template,
  TemplateBaseColorDefinition,
  TemplateDateCellForcedTextDefinition,
} from "../../../../types/customization/template";
import { lengthMmToPx, sizeMmToPx } from "../../../../utils/customization/box";
import {
  findFontColorDefinition,
  findFontDefinition,
} from "../../../../utils/customization/finders";
import { isInterpolatedValueText } from "../../../../utils/customization/format/content";
import {
  calcTextProperties,
  DEFAULT_FONT_COLOR,
  textAlignToCss,
  textOrientationToCss,
} from "../../../../utils/customization/text";
import "./style.scss";

interface Props {
  cellColorDefinition: TemplateBaseColorDefinition | undefined;
  dateCellContent: ContentDateCell;
  elementDefinition: TemplateDateCellForcedTextDefinition;
  ppmm: number;
  template: Template;
}

const DateCellForcedText: FunctionComponent<Props> = ({
  cellColorDefinition,
  dateCellContent,
  elementDefinition,
  ppmm,
  template,
}) => {
  const fontKey = elementDefinition.fontKey;

  const fontDefinition = findFontDefinition(fontKey, template);

  const { boxSize, fontSizeLength, lineHeightLength } = calcTextProperties(
    elementDefinition,
    fontDefinition
  );

  const style: CSSProperties = {
    ...textAlignToCss(elementDefinition.textAlign),
    ...textOrientationToCss(elementDefinition.textOrientation, sizeMmToPx(boxSize, ppmm)),
  };

  const fontColorDefinition = cellColorDefinition
    ? findFontColorDefinition(elementDefinition.fontColorKey, cellColorDefinition)
    : undefined;

  const contentStyle: CSSProperties = {
    color: fontColorDefinition?.value || DEFAULT_FONT_COLOR,
    fontSize: `${lengthMmToPx(fontSizeLength, ppmm).value}px`,
    lineHeight: `${lengthMmToPx(lineHeightLength, ppmm).value}px`,
  };

  let forcedContent: string;
  const valueContent = dateCellContent.interpolatedValues.find(
    (value) => value.childKey === elementDefinition.key
  );
  if (!valueContent) {
    forcedContent = "";
  } else if (valueContent && isInterpolatedValueText(valueContent)) {
    forcedContent = valueContent.value;
  } else {
    forcedContent = valueContent.valueNumber;
  }

  return (
    <div className="DateCellForcedText" style={style}>
      <div
        className={classNames(
          "DateCellForcedText-content",
          fontTagToCssClass(fontDefinition.fontTag)
        )}
        style={contentStyle}
      >
        {forcedContent}
      </div>
    </div>
  );
};

export default DateCellForcedText;
